import { AirParams } from "../air-params"
import { Occupancy } from "../occupancy"
import { AType, summon } from "@silversea-ssc/functional-support"
import { FareCode } from "@silversea-ssc/web-fares-fp"
import { AvailabilityType } from "../availability-type"
import { CruiseCode } from "@ssc-booking/functional-support"

const OldFields = summon((F) =>
    F.interface(
        {
            cruiseCode: CruiseCode(F),
            occupancy: Occupancy(F),
            fareCode: FareCode(F),
            suiteCategory: F.string(),
            vsMember: F.boolean(),
            vsCode: F.nullable(F.string()),
            availabilities: F.nonEmptyArray(AvailabilityType(F)),
            air: AirParams(F),
        },
        "OldFields",
    ),
)

const NewFields = summon((F) =>
    //TODO can partial be removed? This is usually a temporary hack while BE and FE are not aligned
    F.partial(
        {
            ignoreAutomaticPromotions: F.boolean(),
        },
        "NewFields",
    ),
)

export const PriceRequestV2 = summon((F) => F.intersection(OldFields(F), NewFields(F))("PriceRequestV2"))
export type PriceRequestV2 = AType<typeof PriceRequestV2>
